type EventHandler<T> = (payload: T) => void;

class EventBus {
  private listeners: Map<string, EventHandler<any>[]> = new Map();

  emit<T>(eventName: string, payload: T): void {
    const handlers = this.listeners.get(eventName) || [];

    for (const handler of handlers) {
      handler(payload);
    }
  }

  off<T>(eventName: string, handler: EventHandler<T>): void {
    const handlers = this.listeners.get(eventName) || [];

    if (!handlers.includes(handler)) {
      return;
    }

    handlers.splice(handlers.indexOf(handler), 1);
    this.listeners.set(eventName, handlers);
  }

  on<T>(eventName: string, handler: EventHandler<T>): void {
    const handlers = this.listeners.get(eventName) || [];

    if (handlers.includes(handler)) {
      return;
    }

    handlers.push(handler);
    this.listeners.set(eventName, handlers);
  }
}

export default EventBus;
